<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Only">PREFACE</p>
<p class="ORIM-Chapter-Opener-Paragraph">‘Nothing like a little judicious levity,’ says Michael Finsbury in the text: nor can any better excuse be found for the volume in the reader’s hand. The authors can but add that one of them is old enough to be ashamed of himself, and the other young enough to learn better.</p>
<p class="right" style="margin-top:20px;">R. L. S. &amp; L. O.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-1.vue?304bc966